import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';

const Canvas = styled.canvas`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 0;
`;

const INTENSITY_CONFIG = {
    low: { particles: 30, speedMultiplier: 0.5 },
    medium: { particles: 60, speedMultiplier: 1 },
    high: { particles: 100, speedMultiplier: 1.5 }
};

const SnowEffect = ({ intensity = 'medium' }) => {
    const canvasRef = useRef(null);
    const animationRef = useRef(null);
    const particlesRef = useRef([]);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        const config = INTENSITY_CONFIG[intensity] || INTENSITY_CONFIG.medium;

        const resize = () => {
            canvas.width = canvas.offsetWidth;
            canvas.height = canvas.offsetHeight;
        };
        resize();
        window.addEventListener('resize', resize);

        const createParticles = () => {
            particlesRef.current = [];
            for (let i = 0; i < config.particles; i++) {
                particlesRef.current.push({
                    x: Math.random() * canvas.width,
                    y: Math.random() * canvas.height,
                    radius: Math.random() * 3 + 1,
                    speed: (Math.random() * 1 + 0.5) * config.speedMultiplier,
                    wind: Math.random() * 0.5 - 0.25,
                    opacity: Math.random() * 0.6 + 0.4
                });
            }
        };
        createParticles();

        const animate = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            particlesRef.current.forEach(particle => {
                ctx.beginPath();
                ctx.arc(particle.x, particle.y, particle.radius, 0, Math.PI * 2);
                ctx.fillStyle = `rgba(255, 255, 255, ${particle.opacity})`;
                ctx.fill();

                particle.y += particle.speed;
                particle.x += particle.wind;

                if (particle.y > canvas.height) {
                    particle.y = -10;
                    particle.x = Math.random() * canvas.width;
                }
                if (particle.x > canvas.width) particle.x = 0;
                if (particle.x < 0) particle.x = canvas.width;
            });

            animationRef.current = requestAnimationFrame(animate);
        };
        animate();

        return () => {
            window.removeEventListener('resize', resize);
            if (animationRef.current) {
                cancelAnimationFrame(animationRef.current);
            }
        };
    }, [intensity]);

    return <Canvas ref={canvasRef} />;
};

export default SnowEffect;
